import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { unwrapResult } from '@reduxjs/toolkit'
import { fetchPaymentCategory, savePaymentCategory } from "../../../store/thunks/paymentCategoriesThunk";
import { getPaymentCategory, unloadPaymentCategories } from "../../../store/slices/datasources/paymentCategoriesSliceDatasource";
import WithLoadingPage from "../commons/withLoadingPage";
import Flash from "../elements/flash";
import PageSubHeader from "../elements/pageSubHeader";

const PaymentCategoryForm = props => {
    
	const dispatch = useDispatch();
    const history = useHistory();
	const routeParams = useParams();
    const { id: paymentCategoryId } = routeParams;
	const paymentCategory = useSelector(getPaymentCategory(paymentCategoryId));
	const { setLoading } = props;
	const [request, setRequest] = React.useState({ id: null, name: "", description: "" });
	const [error, setError] = React.useState({ name: null });

    React.useEffect(() => {
        return () => {
            dispatch(unloadPaymentCategories());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        async function initialize() {
            setLoading(true)
            if (parseInt(paymentCategoryId)) {
                await dispatch(fetchPaymentCategory(getQueryFilter()));
            }
            setLoading(false);
        }
        
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, paymentCategoryId]); 
	
	React.useEffect(() => {
		if (paymentCategory) {
			const mapViewToModel = {
				id: paymentCategory.id,
				name: paymentCategory.name,
				description: paymentCategory.description
			}

			setRequest(prev => { 
                return { 
                    ...prev, 
                    ...mapViewToModel 
                }
            });
		}
	}, [paymentCategory]);

    const getQueryFilter = () => {
        const queryFilter = {
            id: paymentCategoryId
        };

        return {
            query: queryFilter
        };
    }

	const handleInputChange = element => {
		const { name, value } = element.target;
		setRequest({...request, [name]: value});
	}

	const handleFormSubmit = async event => {
		event.preventDefault();
		setLoading(true);
		await dispatch(savePaymentCategory(request))
			.then(unwrapResult)
			.then(() => {
				setLoading(false);
				setError({ ...error, name: null });
				history.push('/data/payment-categories');
			})
			.catch(exception => {
				setLoading(false);
				setError(exception.errors);
			});
	}

    return (
        <React.Fragment>
            <PageSubHeader title={`${paymentCategoryId === "add" ? "New" : "Edit"} Payment Category`} />
            <div className="mx-auto w-2/4">
                <Flash />
                <div className="classic card">
                    <div className="card-header bg-light-600">
                        <h3 className="card-title">Payment Category Form</h3>
                    </div>
                    <div className="card-body text-left">
                        <form className="w-full" onSubmit={handleFormSubmit}>
                            <div className="form-group">
                                <label className="form-label" htmlFor="name">Name</label>
                                <input id="name" name="name" type="text" className="form-control" value={request.name} onChange={handleInputChange} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="description">Description</label>
                                <textarea id="description" name="description" type="text" className="form-control" value={request.description} onChange={handleInputChange} rows="5" resize="none" />
                            </div>
                            <div className="form-group text-right">
                                <NavLink to="/data/payment-categories" className="btn btn-secondary mr-4">
                                    <i className="las la-undo" />
                                    Back
                                </NavLink>
                                <button className="btn btn-primary mr-4">
                                    <i className="las la-save" />
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
 
export default WithLoadingPage(PaymentCategoryForm);